// Yup
import { object, string } from 'yup';

// Helpers
import { isValidCNPJ } from 'helpers/cnpj';

const bdosRegisterSchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  email: string()
    .email('Por favor digite um e-mail válido')
    .required('Campo e-mail obrigatório'),
  companyName: string().required('Campo nome da empresa obrigatório'),
  cnpj: string()
    .required('Campo CNPJ obrigatório')
    .test('cnpj-valido', 'Digite um CNPJ válido', (value) =>
      isValidCNPJ(value),
    ),
});

export default bdosRegisterSchema;
export { bdosRegisterSchema };
